import { useSelector } from 'react-redux';

import { walkerSlice } from '../slices/walker';

export const useGetWalker = () => {
  const data = useSelector(walkerSlice.selectors.getWalker);

  return data;
};
